import { FC, useState } from 'react';

import Filters from '@/components/Search/components/Filters/Filters';
import { SearchFiltersType } from '@/components/Search/types';
import { getCountActiveFilters } from '@/components/Search/utils';
import Badge from '@/Molecules/Badge/Badge';
import FiltersButton from '@/Molecules/FiltersButton/FiltersButton';
import SidePanel from '@/Organisms/SidePanel/SidePanel';

import useStyles from './styles';

type Props = Pick<
  SearchFiltersType,
  'sidePanelFilters' | 'setSidePanelFilters'
> & {
  isSticky: boolean;
};

const FiltersSection: FC<Props> = ({
  isSticky = false,
  sidePanelFilters,
  setSidePanelFilters,
}) => {
  const { classes } = useStyles();
  const activeFilters = getCountActiveFilters(sidePanelFilters);

  const [isSideOpen, setIsSideOpen] = useState<boolean>(false);

  const filters = (
    <Filters
      availabilities={[]}
      sidePanelFilters={sidePanelFilters}
      setSidePanelFilters={setSidePanelFilters}
    />
  );

  return isSticky ? (
    <div className={classes.filterButton}>
      <FiltersButton onClick={() => setIsSideOpen(true)}>
        {activeFilters > 0 && <Badge color="green">{activeFilters}</Badge>}
      </FiltersButton>
      <SidePanel isOpen={isSideOpen} onClose={() => setIsSideOpen(false)}>
        {filters}
      </SidePanel>
    </div>
  ) : (
    filters
  );
};

export default FiltersSection;
